import { useMemo } from "react"

import { Navigate, useLocation, useRoutes } from "react-router-dom"

import { MapAdapterBoundingBox } from "@l2r-front/l2r-networks"
import { API_MODULE_CAMPAIGN, MODULE_CAMPAIGNS } from "@l2r-front/l2r-shared-campaign"

import { CampaignValidator } from "../CampaignValidator"

export const CampaignContentRouter = () => {
    const { search } = useLocation()

    const campaignRoutes = useMemo(() => {
        return [
            {
                path: `/${MODULE_CAMPAIGNS}/:campaignId`,
                element: <>
                    <MapAdapterBoundingBox key="campaign-details" module={API_MODULE_CAMPAIGN} />
                    <CampaignValidator />
                </>,
            },
            {
                path: `/${MODULE_CAMPAIGNS}`,
                element: <MapAdapterBoundingBox key="campaign-list" module={API_MODULE_CAMPAIGN} />,
            },
            {
                path: "/*",
                element: <Navigate replace to={`./${MODULE_CAMPAIGNS}${search}`} />,

            },
        ]
    }, [search])

    return useRoutes(campaignRoutes)
}